<template>
	<v-sheet height="35%" v-if="topLevel">
		<v-carousel class="campaigns__carousel" eager :cycle="topLevel.length > 1" show-arrows-on-hover height="100%" :show-arrows="topLevel.length > 1" hide-delimiter-background :hide-delimiters="topLevel.length == 1">
			<v-carousel-item v-for="(campaign, i) in topLevel" :key="i" class="main-campaign" style="height: 100%; width: 100%" @click="goToCampaign(campaign)" eager>
				<div style="position: relative; height: 100%">
					<div class="campaign-circle">
						<span class="campaign-circle-text-pricerule1" v-if="campaign.promotionType.promotionTypeName === 'Prisregler' && campaign.benefitRule == 1"> {{ campaign.benefitQty }} for {{ campaign.benefitValue1 }}</span>
						<span class="campaign-circle-text-pricerule2" v-else-if="campaign.promotionType.promotionTypeName === 'Prisregler' && campaign.benefitRule == 2">
							<span class="benefit-amount">{{ campaign.benefitQty }} for</span><br />
							<b class="benefit-value">kr {{ campaign.benefitValue1 }}</b></span
						>
						<div class="campaign-circle-text-tilbud" v-else-if="(campaign.promotionType.promotionTypeName === 'Tilbud' || campaign.promotionType.promotionTypeName === 'Nyhet') && campaign.additionalValue != '0' && campaign.additionalValue">
							<span class="text">Opp til</span>
							<b class="value">{{ campaign.additionalValue }} %</b>
						</div>
						<div class="campaign-circle-text-pricerule3" v-else-if="campaign.benefitRule == 3">
							<b class="value">Kjøp {{ campaign.benefitQty }}, få med 1 ekstra</b>
						</div>
						<div class="campaign-circle-text-pricerule1" v-else>
							<span class="text">{{campaign.promotionType.promotionTypeName}}</span>
						</div>
					</div>
					<v-img :src="campaign.imgUrl" class="mx-auto" lazy-src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8/OlTCAAI5AMtwFOAFgAAAABJRU5ErkJggg==" height="100%" eager> </v-img>
				</div>
			</v-carousel-item>
		</v-carousel>
	</v-sheet>
</template>
<script>
import webshopMixins from '@/components/webshop/cart/webshop.mixins';

export default {
	mixins: [webshopMixins],
	computed: {
		topLevel() {
			return this.campaignsByLevel?.topLevel;
		},
	},
};
</script>
<style lang="scss">
.main-campaign {
	cursor: pointer;
	@media only screen and (min-width: 700px) {
		.campaign-circle {
			position: absolute;
			border-radius: 0 0 100% 0;
			width: 15%;
			height: 20%;
			color: white;
			background-color: #ea412a;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			.campaign-circle-text-pricerule1 {
				left: -20px;
				position: relative;
				font-size: 35px;
				top: -11px;
			}
			.campaign-circle-text-pricerule2 {
				.benefit-amount {
					left: -7%;
					font-size: 25px;
					position: relative;
					top: 1px;
				}
				.benefit-value {
					left: -21%;
					font-size: 35px;
					position: relative;
					top: -10px;
				}
			}
			.campaign-circle-text-pricerule3 {
				font-size: 18px;
				margin-left: 10px;
				position: relative;
				top: -10px;
			}
			.campaign-circle-text-tilbud {
				left: -10px;
				position: relative;
				top: -6px;
				display: flex;
				flex-direction: column;
				.value {
					font-size: 35px;
					margin-top: -11px;
				}
			}
		}
	}
	@media only screen and (max-width: 700px) {
		.campaign-circle {
			position: absolute;
			border-radius: 0 0 100% 0;
			width: 20%;
			height: 30%;
			color: white;
			background-color: #ea412a;
			z-index: 1;
			display: flex;
			align-items: center;
			justify-content: center;
			.campaign-circle-text-pricerule1 {
				left: -12px;
				position: relative;
				font-size: 4vw;
				top: -8px;
			}
			.campaign-circle-text-pricerule2 {
				.benefit-amount {
					left: -7%;
					font-size: 16px;
					position: relative;
					top: 1px;
				}
				.benefit-value {
					left: -21%;
					font-size: 16px;
					position: relative;
					top: -10px;
				}
			}
			.campaign-circle-text-pricerule3 {
				font-size: 12px;
				margin-left: 4px;
				font-weight: lighter;
				position: relative;
				top: -10px;
			}
			.campaign-circle-text-tilbud {
				left: -10px;
				position: relative;
				top: -6px;
				display: flex;
				flex-direction: column;
				.value {
					font-size: 5vw;
					margin-top: -11px;
				}
			}
		}
	}
}
.campaigns__carousel {
	.v-window__container {
		height: 90% !important;
	}
	.v-carousel__controls {
		height: 10% !important;
		position: relative;
		.v-carousel__controls__item {
			color: var(--v-primary-base) !important;
			.v-btn__content {
				opacity: 0.8 !important;
			}
		}
		.v-item--active {
			color: var(--v-primary-base) !important;
			.v-btn__content {
				.v-icon {
					opacity: 1.3 !important;
					font-size: 20px !important;
				}
			}
		}
	}
}
</style>
